var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPassEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.234,
    height: 14.165,
    viewBox: "0 0 23.234 14.165",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    fill: "#0A1C2D",
    d: "M-263.363,9.8a13.119,13.119,0,0,0-11.375-6.944v0c-.643.043-1.1.061-1.569.106a10.334,10.334,0,0,0-1.074.161A13.018,13.018,0,0,0-286.5,9.812a.267.267,0,0,0,0,.3,13.1,13.1,0,0,0,13.811,6.711,12.951,12.951,0,0,0,9.329-6.7A.286.286,0,0,0-263.363,9.8Zm-1.617.3A11.14,11.14,0,0,1-273,15.855a11.268,11.268,0,0,1-11.881-5.773.229.229,0,0,1,0-.254,11.2,11.2,0,0,1,7.847-5.759,9.024,9.024,0,0,1,.923-.139c.4-.039.8-.054,1.35-.091v0a11.286,11.286,0,0,1,9.785,5.973A.246.246,0,0,1-264.98,10.094Z",
    transform: "translate(286.547 -2.85)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    fill: "#0A1C2D",
    d: "M-264.9,8.674a4,4,0,0,1,3.99,4v.031a4,4,0,0,1-4.029,3.961h0a3.992,3.992,0,0,1-3.957-4.02,3.984,3.984,0,0,1,4-3.972Zm2.349,4.543a2.4,2.4,0,0,0-1.417-2.806,2.44,2.44,0,0,0-3.191,1.311l-.021.051a2.385,2.385,0,0,0,.908,2.892,2.01,2.01,0,0,1,1.339-2.12,2.015,2.015,0,0,1,2.378.671Z",
    transform: "translate(276.519 -5.575)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPassEye);
export default __webpack_public_path__ + "static/media/passEye.9e5d54b8.svg";
export { ForwardRef as ReactComponent };